import MY_IMAGE from '@/assets/ads/tcgp.jpeg'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { useAds } from '@/contexts/ads'

import styles from './MidBanner.module.scss'

// Note: (un)comment CSS if separate mobile ad (not) provided

const MidBanner = () => {
  const { loadAds } = useAds()

  // https://www.epochconverter.com
  const enabled = Date.now() > 1747400400000 && Date.now() < 1747450800000

  if (!enabled || loadAds !== true) return null

  return (
    <div className={styles.container}>
      <OutboundLink className={styles.link} url='https://partner.tcgplayer.com/c/4913290/2947965/21018'>
        {/* <img alt='' className='d-none d-sm-block' src={MY_IMAGE.src} />
        <img alt='' className='d-sm-none' src={MY_IMAGE.src} /> */}
        <img alt='' src={MY_IMAGE.src} />
      </OutboundLink>
    </div>
  )
}

export default MidBanner
